import { render, staticRenderFns } from "./VehicleDetailsContainer.vue?vue&type=template&id=3c32fcd2"
import script from "./VehicleDetailsContainer.vue?vue&type=script&lang=js"
export * from "./VehicleDetailsContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports